import { render, staticRenderFns } from "./banner-pc.vue?vue&type=template&id=f48a0918&scoped=true&"
var script = {}
import style0 from "./banner-pc.vue?vue&type=style&index=0&id=f48a0918&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a0918",
  null
  
)

export default component.exports